import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import LoadingAdapter from "libs/utils/LoadingAdapter";
import PersonalService from "services/PersonalService";

let initialState = {
  list: [],
  detail: {},
  addReference: {},
  referenceList: {},
};

export const getPersonalDetail = createAsyncThunk(
  "personal/getPersonalDetail",
  async ({ personalId }) => {
    const response = await PersonalService.getPersonalList({ personalId });
    return response?.results;
  }
);

export const getPersonalList = createAsyncThunk(
  "personal/getPersonalList",
  async ({ personalId, keyword, agentId }) => {
    const response = await PersonalService.getPersonalList({
      personalId,
      keyword,
      agentId,
    });

    return response?.results;
  }
);

export const addPersonalReference = createAsyncThunk(
  "personal/addPersonalReference",
  async ({ referenceID, personalID, refpersonalID, status }) => {
    const response = await PersonalService.addPersonalReference({
      referenceID,
      personalID,
      refpersonalID,
      status,
    });
    return response?.results;
  }
);

export const getPersonalReference = createAsyncThunk(
  "personal/getPersonalReference",
  async (personalID) => {
    const response = await PersonalService.getPersonalReference(personalID);
    return response?.results;
  }
);

export const personalSlice = createSlice({
  name: "personal",
  initialState: LoadingAdapter.getInitialState(initialState),
  reducers: {
    clearAll: () => LoadingAdapter.getInitialState(initialState),
    clearAsyncState: LoadingAdapter.clearAsyncState,
  },
  extraReducers: (builder) => {
    LoadingAdapter.applyAsyncBuilder(getPersonalList, builder, ["list"]);
    LoadingAdapter.applyAsyncBuilder(getPersonalDetail, builder, [
      "detail",
    ]).onSuccess((state, action) => {
      state.detail = action.payload[0] || {};
    });
    LoadingAdapter.applyAsyncBuilder(addPersonalReference, builder, [
      "addReference",
    ]);
    LoadingAdapter.applyAsyncBuilder(getPersonalReference, builder, [
      "referenceList",
    ]);
  },
});

export const selectPersonalState = (state) => state.personal;
export const selectPersonalDetail = (state) => state.personal.detail;

export default personalSlice.reducer;
